import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-pause_audio",
  "use": "icon-pause_audio-usage",
  "viewBox": "0 0 960 960",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 960 960\" id=\"icon-pause_audio\"><g fill=\"none\" fill-rule=\"evenodd\"><circle cx=\"480\" cy=\"480\" r=\"480\" fill=\"#46A0F0\" /><rect fill=\"#FFF\" x=\"272\" y=\"256\" width=\"128\" height=\"448\" rx=\"64\" /><rect fill=\"#FFF\" x=\"560\" y=\"256\" width=\"128\" height=\"448\" rx=\"64\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol